import { wallItems } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

export default function WallGrid() {
  return (
    <section id="wall" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="CARD WALL"
          title="爆料卡片墙 · 大小混排"
          desc="分成大卡与小卡两层信息量：大卡看脉络，小卡抓细节。扫一眼就能定位你最想深挖的那一块。"
          actionHref="#archive"
          actionLabel="全部实锤归档"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {wallItems.map((item) => {
            const isLarge = item.size === 'large';
            return (
              <a
                key={item.id}
                href="#dig"
                className={`group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors ${
                  isLarge ? 'sm:col-span-2 lg:col-span-2' : ''
                }`}
              >
                <div
                  className={`relative w-full overflow-hidden bg-background-200 ${
                    isLarge ? 'h-[220px] md:h-[300px]' : 'h-[170px]'
                  }`}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 18爆料网爆料卡片`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 text-[11px] font-medium backdrop-blur">
                    {item.tag}
                  </span>
                </div>
                <div className={`flex flex-col flex-1 ${isLarge ? 'p-5 md:p-6' : 'p-4'}`}>
                  <h3
                    className={`font-heading font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors ${
                      isLarge ? 'text-lg md:text-xl' : 'text-base line-clamp-2'
                    }`}
                  >
                    {item.title}
                  </h3>
                  {isLarge && item.summary && (
                    <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.summary}</p>
                  )}
                  <span className="mt-auto pt-3 text-xs text-foreground-400">{item.meta}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}